module.exports = __webpack_public_path__ + "img/qtcon.ad65dda8.svg";